// src/components/ConfirmationModal/ConfirmationModal.jsx

import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const ConfirmationModal = ({ title, body, onConfirm, onCancel, isProcessing }) => {
  const { t } = useTranslation();

  return (
    <Modal show onHide={onCancel} centered backdrop="static" keyboard={!isProcessing}>
      <Modal.Header closeButton={!isProcessing}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={isProcessing}>
          {t('cancel')}
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={isProcessing}>
          {isProcessing ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{' '}
              {t('deleting')}
            </>
          ) : (
            t('confirm')
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool,
};

ConfirmationModal.defaultProps = {
  isProcessing: false,
};

export default ConfirmationModal;
